import "assets/scss/pages/home.scss";

import { Box, Container, Grid, Stack } from "@mui/material";
import { Common, Custom, FormFeedback, Page } from "components";
import { useApp, useTheme } from "contexts";
import { Helpers, Routes } from "utils";
import { useNavigate } from "react-router-dom";
import { Combines } from "helpers";

type Props = {};

export const Feedback = (props: Props) => {
  const navigate = useNavigate();

  const { t } = useApp();
  const { theme } = useTheme();

  return (
    <Box pt={theme.spacing.sm}>
      <Stack gap={theme.spacing.xxl}>
        <Container>
          <Grid container>
            <Grid item xs={12} md={4}>
              <Box py={theme.spacing.xxxl}>
                <Stack spacing={theme.spacing.sm}>
                  <Stack spacing={theme.spacing.sm}>
                    <Custom.Typography
                      size={theme.font.lg}
                      weight={theme.font.bold}
                    >
                      {t.page.feedback.header}
                    </Custom.Typography>
                    <Custom.Typography
                      component="pre"
                      whiteSpace="pre-wrap"
                      size={theme.font.xs}
                      weight={theme.font.normal}
                    >
                      {t.page.feedback.subheader}
                    </Custom.Typography>
                  </Stack>

                  <FormFeedback.Form onSubmit={() => {}} />
                </Stack>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              sx={{
                top: 0,
                display: { xs: "none", md: "flex" },
                height: "100vh", // Ensures it takes up full height
                position: "sticky",
                overflow: "hidden", // Prevents internal scrolling
                alignItems: "center", // Centers image if needed
                justifyContent: "center",
              }}
            >
              <Common.Image src={Helpers.getImage("feedback_art.png")} />
            </Grid>
          </Grid>
        </Container>
      </Stack>
    </Box>
  );
};
